// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"214":"0e94db71a4b785c4","679":"ab91f5d5578ac5d9"}[chunkId] + ".js";
};